module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.a25e8903639374c180cf.js");
};